'use client';

import { TableCell, TableRow } from '@pickleballinc/features/src/table';

interface StatsTableRowProps {
	id: number;
	invoice: string;
	datePaid: string;
	description: string;
	paymentMethod: string;
	amount: string;
	transactionsDataLength: number;
}

export const TransactionsTableRow = ({ id, invoice, datePaid, description, paymentMethod, amount, transactionsDataLength }: StatsTableRowProps) => {
	const tableCellStyle = 'px-3 py-4 sm:px-6 text-sm not-italic leading-5 text-start text-gray-900';

	return (
		<TableRow className="h-[72px] items-center text-sm font-normal leading-5 odd:bg-white even:bg-brand-25">
			<TableCell className={`${tableCellStyle} font-medium ${id == transactionsDataLength - 1 ? 'rounded-bl-lg' : ''}`}>{invoice}</TableCell>
			<TableCell className={`${tableCellStyle} text-nowrap font-medium`}>{datePaid}</TableCell>
			<TableCell className={`${tableCellStyle} font-normal`}>{description}</TableCell>
			<TableCell className={`${tableCellStyle} font-normal`}>{paymentMethod}</TableCell>
			<TableCell className={`${tableCellStyle} font-normal ${id == transactionsDataLength - 1 ? 'rounded-br-lg' : ''}`}>{amount}</TableCell>
		</TableRow>
	);
};
